(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart_visionsync-bundle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-av-bundle-upgrade]');
  if (!button || button.disabled) return;
  const panel = button.closest('[data-av-cart-bundle]');
  const drawer = button.closest('cart-drawer');
  const input = drawer?.querySelector('#Drawer-quantity-' + button.dataset.line);
  const status = panel.querySelector('[data-av-bundle-status]');
  if (!input || !input.closest('cart-drawer-items')) {
    status.textContent = status.dataset.error;
    return;
  }
  panel.querySelectorAll('button').forEach(el => { el.disabled = true; });
  panel.setAttribute('aria-busy', 'true');
  status.textContent = status.dataset.updating;
  input.value = button.dataset.quantity;
  input.dispatchEvent(new Event('change', {bubbles:true}));
  setTimeout(() => {
    if (!panel.isConnected) return;
    panel.querySelectorAll('button').forEach(el => { el.disabled = false; });
    panel.removeAttribute('aria-busy');
    status.textContent = '';
  }, 8000);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avenor-visionsync-buttons')) {
  customElements.define('avenor-visionsync-buttons', class extends HTMLElement {
    connectedCallback() {
      const info = this.closest('product-info');
      if (!info) return;
      const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
      const update = () => {
        this.frame = null;
        const content = this.querySelector('.av-vs-atc-content');
        if (!content) return;
        const selected = info.querySelector('.kaching-bundles__bar--selected');
        const priceBox = info.querySelector('.product-page-price');
        const price = selected?.querySelector('.kaching-bundles__bar-price') || priceBox?.querySelector('.price-item--sale') || priceBox?.querySelector('.main-price');
        const original = selected?.querySelector('.kaching-bundles__bar-full-price') || priceBox?.querySelector('.main-comapre-price');
        const priceText = price?.textContent.trim() || '';
        const originalText = original?.textContent.trim() || '';
        const compare = content.querySelector('.av-vs-atc-compare');
        setText(content.querySelector('.av-vs-atc-action'), content.dataset.action);
        if (priceText) setText(content.querySelector('.av-vs-atc-price'), priceText);
        setText(compare, originalText);
        const hideCompare = !originalText || originalText === priceText;
        if (compare.hidden !== hideCompare) compare.hidden = hideCompare;
      };
      this.observer = new MutationObserver(() => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      });
      this.observer.observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'data-unavailable'] });
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
